"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBusesBridge = void 0;
class EventBusesBridge {
    constructor(eventBuses) {
        this.eventBuses = eventBuses;
    }
    static create(eventBuses) {
        const eventBus = new EventBusesBridge(eventBuses);
        eventBus.subscribeBroadcast();
        return eventBus;
    }
    subscribeBroadcast() {
        this.eventBuses.forEach(eventBus => {
            eventBus.getTypes().forEach(type => {
                eventBus.subscribe(type, event => {
                    if (!event.isBroadcast()) {
                        const broadcastEvent = event.clone();
                        broadcastEvent.setBroadcast(true);
                        this.publishBroadcast(type, broadcastEvent, eventBus.id);
                    }
                });
            });
        });
    }
    publishBroadcast(type, event, eventBusDestination) {
        this.eventBuses.forEach(eventBus => {
            if (eventBusDestination !== eventBus.id) {
                eventBus.publish(type, event);
            }
        });
    }
}
exports.EventBusesBridge = EventBusesBridge;
//# sourceMappingURL=eventBusBridge.js.map